// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"f6e0f2c4","67":"c08679c6","732":"f138e348"}[chunkId] + ".chunk.js";
};